module.exports = __webpack_public_path__ + "static/media/woman_07.edcfa060.png";